import DatePicker from './src/date-picker'

export default DatePicker
